import { SET_VIEWPORT, SHOW_ERROR, HIDE_ERROR } from "../actionTypes";

export function setViewport(payload) {
  return {
    type: SET_VIEWPORT,
    payload,
  };
}

export const showErrorMsg = (dispatch) => {
  dispatch({ type: SHOW_ERROR });
};

export const hideErrorMsg = (dispatch) => {
  dispatch({ type: HIDE_ERROR });
};
